// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2NB8n","description":"PatientConsentPreview_description__hJQR-"};